












































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import DetailHeader from "../components/DetailHeader.vue";
import CompleteJob from "../components/completeJob/CompleteJob.vue";
import IssueList from "../components/completeJob/IssueList.vue";
import axios from "axios";
import { Job } from "../common/interfaces";
import moment from "moment";
import store from "@/store/store";
import { ActionNames } from "@/store/actions";
import { loadJobDetail, loadParts } from "@/common/jobLoader";

@Component({
  components: {
    DetailHeader,
    CompleteJob,
    IssueList,
  },
})
export default class JobDetail extends Vue {
  protected loadingJob: boolean = true;
  protected completeJob: boolean = false;
  protected showIssueList: boolean = false;
  protected issueList: string[] = [];
  protected showRote: boolean = false;
  protected rotePreference: boolean = false;

  public created() {
    this.$watch(() => this.$route.params.id, this.loadJob);
    this.loadJob(this.$route.params.id);
  }

  public async loadJob(jobId: string) {
    this.loadingJob = true;
    try {
      await loadJobDetail(jobId);
    } catch (err) {
      this.$router.push("/");
      this.$notify.error({
        title: "Error",
        message: err.message,
        offset: 48,
      });
    } finally {
      this.loadingJob = false;
      this.showRote = this.jobDetail ? !!this.jobDetail!.ROTEIncluded : false;
      this.rotePreference = this.showRote;
    }
  }

  public displayDate(date: moment.Moment) {
    return date.isValid() ? date.format("DD-MMM-YYYY") : "No Date";
  }

  public checklistClicked() {
    this.$router.push(`${this.$route.path}/Checklist`);
  }

  public nearbyJobsClicked() {
    this.$router.push(`/ByPostcode/${this.jobDetail!.AddressPostcode}`);
  }

  public examDetailsClicked() {
    this.$router.push(`${this.$route.path}/ExamDetail`);
  }

  public requiredPartsClicked() {
    this.$router.push(`${this.$route.path}/ExamDetail/Parts`);
  }

  public async customerSignatureClicked() {
    this.loadingJob = true;

    // Make sure all sections of the quote are loaded as they are needed to confirm a job
    // loadParts will load everything
    try {
      await loadParts(store.state.Job.JobId.toString());
      this.loadingJob = false;
      // Show ROTE confirmation dialog
      this.showIssueList = true;
    } catch (err) {
      this.loadingJob = false;
      this.$notify.error({
        title: "Error",
        message: err.message,
        offset: 48,
      });
    }
  }

  public validateJobForIssues() {
    const issueList: string[] = [];
    const examDetail = store.state.Job.ExamDetail;
    if (examDetail) {
      if (this.emptyOrValue(examDetail.ProofLoad) === "") {
        issueList.push("The proof load has not been entered.");
      }
      if (this.emptyOrValue(examDetail.Radius) === "") {
        issueList.push("The radius has not been entered.");
      }
      if (
        !examDetail.LiftSafe &&
        this.emptyOrValue(examDetail.DefectDetails) === ""
      ) {
        issueList.push(
          "The lift is not marked as safe, but no defect details have been filled out."
        );
      }
      if (
        !examDetail.LiftSafe &&
        this.emptyOrValue(examDetail.DefectRemedy) === ""
      ) {
        issueList.push(
          "The lift is not marked as safe, but no remedy has been suggested."
        );
      }
      if (!this.isDateFieldValid(examDetail.ArrivedOnSite)) {
        issueList.push("The 'arrived on site' time has not been set.");
      }
      if (
        this.emptyOrValue(examDetail.DefectDetails) !== "" &&
        this.emptyOrValue(examDetail.DefectDetails) !==
          store.state.EMPTY_STRING &&
        this.emptyOrValue(examDetail.DefectWork) === ""
      ) {
        issueList.push(
          "No details of work carried out have been entered, but defects are present."
        );
      }

      /*
      We have decided to not make Checklists mandatory 
      if (!this.isChecklistValid()) {
        issueList.push(
          "The checklist is not completed."
        );
      }
      */
    } else {
      issueList.push("Could not load Exam Detail.");
    }

    this.issueList = issueList;
  }

  public isChecklistValid() {
    if (store.state.Job.ChecklistQAs) {
      return !Object.keys(store.state.Job.ChecklistQAs).some((k) => {
        return store.state.Job.ChecklistQAs![k] === "";
      });
    }
    return false;
  }

  public completeJobClosed() {
    this.completeJob = false;
  }

  public async issueListClosed() {
    // If rote is true, set next due to today + year
    if (this.rotePreference) {
      await this.updateNextRoteDue(moment().add(1, "year").startOf("day"));
      this.examDetailsClicked();
    } else {
      this.completeJob = true;
    }
    // reset issue list to make sure
    this.issueList = [];
    this.showIssueList = false;
  }

  public async bookingDateSelected(newDate: string) {
    const currentBookedInDateTime = this.jobDetail!.BookedInDateTime;
    const bookedInDateTime: moment.Moment = moment(newDate);
    bookedInDateTime.set({
      hour: currentBookedInDateTime ? currentBookedInDateTime.get("hour") : 0,
      minute: currentBookedInDateTime
        ? currentBookedInDateTime.get("minute")
        : 0,
    });
    this.updateBookedInDate(bookedInDateTime);
  }

  public bookingTimeSelected(newTime: string) {
    const bookedInDateTime: moment.Moment =
      moment(this.jobDetail!.BookedInDateTime) || moment();
    const timeParts = newTime.split(":");
    bookedInDateTime.set({
      hour: parseInt(timeParts[0], 10),
      minute: parseInt(timeParts[1], 10),
    });
    this.updateBookedInDate(bookedInDateTime);
  }

  public async updateBookedInDate(newValue: moment.Moment) {
    try {
      await store.dispatch(ActionNames.SetBookedInDateTime, newValue);
    } catch (err) {
      this.$notify.error({
        title: "Error",
        message: err.message,
        offset: 48,
      });
    }
  }

  public async setRoteIncluded(newValue: boolean | null) {
    try {
      await store.dispatch(ActionNames.SetRoteIncluded, newValue);
    } catch (err) {
      this.$notify.error({
        title: "Error",
        message: err.message,
        offset: 48,
      });
    }
  }

  public async nextRoteDueSelected(newDate: string) {
    const currentNextRoteDue = moment(this.nextRoteDue);
    const nextRoteDue: moment.Moment = moment(newDate);
    nextRoteDue.set({
      hour: currentNextRoteDue ? currentNextRoteDue.get("hour") : 0,
      minute: currentNextRoteDue ? currentNextRoteDue.get("minute") : 0,
    });
    this.updateNextRoteDue(nextRoteDue);
  }

  public async updateNextRoteDue(newValue: moment.Moment) {
    try {
      await store.dispatch(ActionNames.SetNextRoteDue, newValue);
    } catch (err) {
      this.$notify.error({
        title: "Error",
        message: err.message,
        offset: 48,
      });
    }
  }

  private emptyOrValue(value: string | undefined): string {
    return (value || "").trim();
  }

  private isDateFieldValid(value: moment.Moment | undefined): boolean {
    return value ? value.isValid() : false;
  }

  get jobId() {
    return store.state.Job.JobId;
  }

  get jobDetail() {
    return store.state.Job.JobDetail;
  }

  get detailDescription() {
    if (this.jobDetail) {
      return `(${store.state.Job.JobId}) ${
        this.jobDetail!.TypeDescription
      } details for ${this.jobDetail!.DivisionName}`;
    }
  }

  get bookingTime() {
    let bookedInTime: string = "00:00";
    if (this.jobDetail!.BookedInDateTime) {
      bookedInTime = this.jobDetail!.BookedInDateTime!.isValid()
        ? this.jobDetail!.BookedInDateTime!.format("HH:mm")
        : "00:00";
    }
    return bookedInTime;
  }

  get roteIncluded() {
    return this.jobDetail!.ROTEIncluded;
  }

  get nextRoteDue() {
    // If not set show as today + year
    return (
      this.jobDetail!.NextRoteDue || moment().startOf("day").add(1, "year")
    );
  }

  get contactFullName() {
    const forename = this.jobDetail!.ContactForename
      ? this.jobDetail!.ContactForename
      : "";
    const surname = this.jobDetail!.ContactSurname
      ? this.jobDetail!.ContactSurname
      : "";
    return `${forename} ${surname}`;
  }
}
